import { CITIES_974, nearestCities, aVille, deVille } from "./cities974.mjs";

export const SITE = "https://marabout-reunion.com";
export const NAME = "Maître Diamma";
export const PHONE = "+33 7 45 44 96 41";

export const CITIES = Object.fromEntries(Object.entries(CITIES_974).map(([k, v]) => [k, v.name]));

const SERVICES = { "retour-affectif": "Retour affectif", marabout: "Marabout", voyant: "Voyant", medium: "Médium" };

const WORDS = {
  reunion: "Réunion", etre: "être", aime: "aimé", desenvoutement: "désenvoûtement", envoutement: "envoûtement",
  voyance: "voyance", medium: "médium", infidele: "infidèle", eviter: "éviter", probleme: "problème",
  serieux: "sérieux", temoignage: "témoignage", temoignages: "témoignages", recommande: "recommandé",
  separation: "séparation", a: "à", propos: "propos", faq: "FAQ", ex: "ex",
};

const OVERRIDES = {
  "a-propos": "À propos de Maître Diamma, marabout à La Réunion",
  temoignages: "Témoignages et avis clients – Marabout Réunion 974",
  contact: "Contacter Maître Diamma – Marabout Réunion 974",
  faq: "Questions fréquentes – Marabout Réunion 974",
};

const humanize = (slug) => {
  const s = slug.split("-").map((w) => WORDS[w] || w).join(" ");
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const getSeoPage = (path) => {
  const slug = path.replace(/^\/+|\/+$/g, "").toLowerCase();
  const cityKey = Object.keys(CITIES).sort((a, b) => b.length - a.length).find((k) => slug.includes(k));
  const city = cityKey ? CITIES[cityKey] : null;
  const service = SERVICES[Object.keys(SERVICES).find((k) => slug.startsWith(k))] || "Marabout";

  if (city) {
    const c = CITIES_974[cityKey];
    const q = c.quartiers.slice(0, 3).join(", ");
    const voisins = nearestCities(cityKey);
    const a = aVille(city);
    return {
      slug, city, h1: `${service} ${a} (${c.cp}) – ${NAME}`,
      local: { ...c, key: cityKey, voisins },
      title: `${service} ${city} ${c.cp} | ${NAME} – Retour Affectif La Réunion`,
      description: `${service} ${a} (${c.cp}), dans ${c.zone} de La Réunion : ${NAME}, marabout voyant médium africain. Retour affectif, désenvoûtement, protection à ${q}. ☎ ${PHONE}`,
      intro: [
        `Vous cherchez un ${service.toLowerCase()} sérieux ${a} (${c.cp}) ? ${NAME} accompagne les habitants ${deVille(city)}, dans ${c.zone} de La Réunion, avec des années d'expérience et une discrétion totale.`,
        `Dans tous les quartiers ${deVille(city)} (${q}…), ${NAME} vous aide pour le retour affectif, le retour de l'être aimé, le désenvoûtement et la protection spirituelle, en consultation ou à distance.`,
        `Problème de couple, ex qui ne revient pas, infidélité, jalousie ou blocage amoureux ${a} ou ${aVille(voisins[0].name)} : contactez ${NAME} pour un premier diagnostic.`,
      ],
    };
  }
  const label = OVERRIDES[slug] || `${humanize(slug)}${/reunion|974/.test(slug) ? "" : " à La Réunion"}`;
  return {
    slug, city: null, h1: `${label}`,
    title: OVERRIDES[slug] ? label : `${label} | ${NAME} – Marabout Réunion 974`,
    description: `${label} : ${NAME}, marabout voyant médium à La Réunion (974). Retour affectif, désenvoûtement, protection. Saint-Denis, Saint-Pierre, Le Tampon, Saint-Paul. ☎ ${PHONE}`,
    intro: [
      `${NAME} est un marabout voyant médium africain reconnu dans toute l'île de La Réunion (974). Des années d'expérience au service de ses clients.`,
      `Retour affectif, retour de l'être aimé, désenvoûtement, protection, chance et travail : intervention à Saint-Denis, Saint-Paul, Saint-Pierre, Le Tampon, Saint-André, Saint-Louis, Le Port et dans les 24 communes de La Réunion.`,
      `Consultation confidentielle par téléphone ou WhatsApp, 7j/7.`,
    ],
  };
};
